// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxInput_wrapper__L4IXI","circle":"CheckboxInput_circle__JCm50"};